__turbopack_context__.v({
  "button": "o3X8La_button",
  "button__disabled": "o3X8La_button__disabled",
  "button__loading": "o3X8La_button__loading",
  "container": "o3X8La_container",
  "shimmer": "o3X8La_shimmer",
  "text-bar-sweep": "o3X8La_text-bar-sweep",
});
